module.exports = __webpack_public_path__ + "static/img/imgContent1.f363db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgContent1.jpg
// module id = jXCz
// module chunks = 0